





import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcSubtitle2 extends Vue{
  @Prop({default:'h2'})
  tag!:string
}
